module.exports = __webpack_public_path__ + "img/info-oven.609cd174.jpg";